import "core-js/modules/es.array.iterator.js";
import { DropPreview } from '@isyc-react/form-file/modules/drop-file/drop-preview';
import React from 'react';
import { DocumentalValidationStatus } from "../documental-validation-status";
export const NewoDropMultiFileListItem = props => {
  var _value$api;
  const {
    value,
    archiveInputState,
    documentalTypologyResult,
    remove
  } = props;
  const [preview, setPreview] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center pb-4 pb-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-5 pt-2 pt-xl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "justify-content-center justify-content-xl-start align-items-center pb-2 pb-xl-0"
  }, /*#__PURE__*/React.createElement("u", {
    className: "cursor-pointer",
    onClick: () => setPreview(true)
  }, value.file ? /*#__PURE__*/React.createElement(React.Fragment, null, value.file.name) : /*#__PURE__*/React.createElement(React.Fragment, null, (_value$api = value.api) === null || _value$api === void 0 ? void 0 : _value$api.name)))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center ps-3 justify-content-xl-start align-items-center"
  }, /*#__PURE__*/React.createElement(DocumentalValidationStatus, {
    documentalTypologyResult: documentalTypologyResult,
    archiveInputState: archiveInputState
  }))), /*#__PURE__*/React.createElement(DropPreview, {
    value: value,
    show: preview,
    onChange: setPreview
  })));
};